import { Box } from '@mui/material'
import ReachLineChart from 'components/Charts'
import ReachAfrikaDatePicker from 'components/DateRangePicker'
import React, { useState } from 'react'
import { BsChevronRight } from 'react-icons/bs'
import useSWR from 'swr'
import Header from './Header'
import { useNavigate } from 'react-router-dom'
function LoyalMetrics() {
  const { data } = useSWR('dashboard/loyalty-metrics')
  const navigate = useNavigate()

  const metrics = [
    { name: 'Total Customers', number: '120', key: 'total' },
    { name: 'New Customers', number: '8', key: 'new' },
    { name: 'Returning Customers', number: '76', key: 'returning' },
    { name: 'Lost Customers', number: '2', key: 'inactive' },
  ]
  const [selected, setSelected] = useState(null)
  const getParam = (data) => {
    console.log(data)
  }

  const graphData = [{ name: '100', pv: '100' }, { name: '300', pv: '200' }, { name: 50, pv: '300' }, { name: 70, pv: '600' }, { name: 400, pv: '800' }, { name: 50, pv: '1000' },];
  return (
    <>
      {selected && <div className='h-[100vh] w-[100vw] bg-[black] fixed top-0 left-0' style={{ opacity: .5, zIndex: '1000' }} onClick={() => setSelected(null)}></div>}
      {
        selected && <div className='h-[70vh] bg-white fixed py-[40px] px-[64px] w-[70vw] rounded-[20px] shadow' style={{ left: '50%', top: '50%', transform: 'translate(-50%,-50%)', zIndex: '1000' }}>
          <div className='w-100 flex justify-between items-center'>
            <div className='text-[#657585] font-[700] text-md'>{selected?.name}</div>
            <div className='w-[50%] flex pl-[10%]' style={{ justifyContent: 'right' }}>
              <ReachAfrikaDatePicker onChange={(val) => getParam(val)} />
            </div>
          </div>
          <Box className='my-3 text-[#05213D] font-[400]' sx={{ fontSize: { xs: '20px', lg: "40px" } }}>
            {selected?.number}
          </Box>
          <div className='h-[40vh]'>
            <ReachLineChart data={graphData} />
          </div>
        </div>
      }
      <div className='w-1/2 min-w-[700px] rounded-[16px] my-[24px] h-[100%] bg-white py-[20px] px-[40px]'>
        <Header text={'Loyalty Metrics'} />

        <div className='flex flex-col h-[100%]'>

          {
            metrics.map(({ name, number, key }, i) => {
              return (
                <div onClick={() => navigate(`/customers/${key}_customers`)} className={'flex px-[12px] w-full h-[86px] cursor-pointer hover:bg-input items-center items-center justify-between border-b'} key={key}>
                  <div className='text-[20px] font-[400] !h-[fit-content]  text-[#05213D]'>{name}</div>
                  <div className='flex gap-[24px] items-center'>
                    <div style={{ fontWeight: 'bold' }}>{data ? Object.values(data?.data)[i] : ''} </div>
                    <div ><BsChevronRight style={{ fontWeight: 'bold' }} /></div>
                  </div>
                </div>
              )
            })
          }
        </div>

      </div>
    </>
  )
}

export default LoyalMetrics